//todo: REFACTOR
export interface PageMetaDtoParametersInterface {
  pageOptionsDto: any;
  itemCount: number;
}
